import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function CheckIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M19.5357 7.52495C19.8256 7.22911 19.8208 6.75426 19.5249 6.46434C19.2291 6.17442 18.7543 6.17922 18.4643 6.47505L10.0928 15.0175C9.60265 15.5176 8.79735 15.5176 8.30723 15.0175L5.53566 12.1893C5.24574 11.8935 4.77089 11.8887 4.47505 12.1786C4.17922 12.4685 4.17442 12.9434 4.46434 13.2392L7.23591 16.0674C8.31417 17.1676 10.0858 17.1676 11.1641 16.0674L19.5357 7.52495Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CircleCheckIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z"
        fill="currentColor"
      />
      <path
        d="M17.2812 8.21393C16.9912 7.92447 16.5241 7.92943 16.2401 8.22467L10.8388 13.8438C10.6209 14.07 10.2655 14.0701 10.0478 13.8438L8.25967 11.9835C7.97573 11.6881 7.5086 11.6832 7.21865 11.9727C6.93139 12.2597 6.92653 12.7279 7.20791 13.0206L8.996 14.8809C9.78993 15.7066 11.0965 15.7065 11.8905 14.8809L17.2919 9.26178C17.5732 8.96907 17.5685 8.50092 17.2812 8.21393Z"
        fill="currentColor"
      />
    </svg>
  )
}
